<template>
    <div class="file-upload dropzone" :id="id">
        <div class="row">
            <div class="col-12 text-center mb-2 col-md text-md-left mb-md-0 dropzone-button">
                <button
                    type="button"
                    class="btn btn-danger"
                    v-show="files.length > 0"
                    @click.prevent="removeFiles"
                >
                    Remove
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    v-show="files.length === 0"
                >
                    Choose File
                </button>
            </div>
            <div class="col-12 col-md dropzone-preview"></div>
        </div>
    </div>
</template>

<script>
import Dropzone from "dropzone";

export default {
    props: {
        id: {type: String, required: true},
        url: {type: String, required: true},
    },

    data() {
        return {
            files: [],
        }
    },

    methods: {
        removeFiles() {
            this.dropzone.removeAllFiles();
            this.files = [];
        }
    },

    mounted() {
        let token = document.head.querySelector('meta[name="csrf-token"]');
        Dropzone.autoDiscover = false;

        this.dropzone = new Dropzone(`#${this.id}`, {
            url: this.url,
            paramName: "file",
            maxFiles: 1,
            withCredentials: true,
            headers: {"X-CSRF-Token": token.content},
            clickable: `#${this.id} .btn-primary`,
            previewsContainer: `#${this.id} .dropzone-preview`,
            hiddenInputContainer: `#${this.id} .dropzone-preview`,
            thumbnailMethod: "contain",
        });

        this.dropzone.on("success", (file, response) => {
            this.$emit("uploaded", file, response, this.id);
            this.files.push(file)
        });

        this.dropzone.on("error", (file, response) => {
            this.$emit("error", file, response, this.id);
            this.files.push(file)
            setTimeout(this.removeFiles, 3000);
        });
    },
};
</script>
